import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Router, NavigationEnd, ActivatedRoute} from '@angular/router';
import {filter, map, mergeMap} from 'rxjs/operators';
import {BreadcrumbService} from './breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})

export class AppBreadcrumbComponent implements OnInit {
  @Input() layout;
  pageInfo = {
    title: '',
    urls: []
  };

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private readonly breadcrumbService: BreadcrumbService) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).pipe(map(() => this.activatedRoute))
      .pipe(
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter(route => route.outlet === 'primary'))
      .pipe(mergeMap(route => route.data))
      .subscribe(event => {
        this.titleService.setTitle(event['title']);
        this.pageInfo = event as { title: string, urls: any[] };
      });

    this.breadcrumbService.breadcrumbChanged$.subscribe(newBreadCrumb => {
      this.pageInfo.urls = newBreadCrumb;
    });

    this.breadcrumbService.titleChanged$.subscribe(newTitle => {
      this.titleService.setTitle(newTitle);
      this.pageInfo.title = newTitle;
    });
  }

  ngOnInit() {}

}
